var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"mt-0",attrs:{"value":_vm.value,"row":"","disabled":_vm.readonly},on:{"change":val => _vm.$emit('input', val)}},[_c('v-radio',{attrs:{"label":"Nee","color":"error","value":0}}),_c('v-radio',{attrs:{"label":"Ja","color":"success","value":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }